export const getViewPortWidth = (): number => {
  return Math.min(document.documentElement.clientWidth, window.innerWidth || 0)
}
